import { BaseApiClient } from './base-client';

/**
 * Model Info API - методы для документации моделей
 */
export class ModelInfoApi extends BaseApiClient {

  /**
   * Get model info/documentation content
   */
  async getModelInfo(provider: string, model: string): Promise<any> {
    const response = await this.client.get(`/api/model-info/${provider}/${model}`);
    return response.data;
  }

  /**
   * Save model info/documentation content (admin only)
   * @param targetModels - null = only own model, ['*'] = universal, ['a','b'] = targeted
   */
  async updateModelInfo(
    provider: string,
    model: string,
    content: any,
    targetModels?: string[] | null
  ): Promise<any> {
    const response = await this.client.post(`/api/model-info/${provider}/${model}`, {
      content,
      targetModels: targetModels ?? null,
    });
    return response.data;
  }

  /**
   * Delete uploaded files from S3
   */
  async deleteFiles(s3Keys: string[]): Promise<any> {
    const response = await this.client.post('/api/storage/delete-files', { s3Keys });
    return response.data;
  }
}
